// State object
import axios from '../../axios-instance'
const initialState = () => ({
  currentUser: {
    data: {
      id: null,
      email: ''
    },
    error: null
  },
  allSubscriptions: { data: null, error: null }
})

const state = initialState()
// Getter functions
const getters = {
  subscriptionsNotConnectedToUser: function (state, getters, rootState) {
    let allCustomerSubscriptions = rootState.customer.allSubscriptions.data
    let allUserSubscriptions = state.allSubscriptions.data
    if (allCustomerSubscriptions === null && allUserSubscriptions === null) {
      return []
    }
    if (allCustomerSubscriptions.length > 0 && allUserSubscriptions.length === 0) {
      return allCustomerSubscriptions
    }

    let difference = JSON.parse(JSON.stringify(allCustomerSubscriptions))
    for (let i in allUserSubscriptions) {
      let index = difference.findIndex(function (item) {
        return item.id === allUserSubscriptions[i].id
      })
      if (index >= 0) {
        difference.splice(index, 1)
      }
    }
    return difference
  }
}
// Mutations
const mutations = {
  setCurrentUser: function (state, user) {
    state.currentUser.data.id = user.data.id
    state.currentUser.data.email = user.data.email
    state.currentUser.error = user.error
  },
  setCurrentUserError: function (state, error) {
    state.currentUser.error = error
  },
  setAllSubscriptions: function (state, subscriptions) {
    state.allSubscriptions = subscriptions
  },
  setAllSubscriptionsError: function (state, error) {
    state.allSubscriptions.error = error
  },
  removeSubscription: function (state, subId) {
    let index = state.allSubscriptions.data.findIndex(function (item) {
      return subId === item.id
    })
    if (index >= 0) {
      state.allSubscriptions.data.splice(index, 1)
    }
  },
  resetStates: function (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
}
// Actions
const actions = {
  /* -------FETCH-------- */
  fetchUser: function (context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/customers/' + payload.customerId + '/subscriptionusers/' + payload.userId
      })
        .then(response => {
          context.commit('setCurrentUser', { data: response.data, error: null })
          resolve()
        })
        .catch(error => {
          context.commit('setCurrentUserError', error.message)
        })
    })
  },
  fetchUserSubscriptions: function (context, payload) {
    axios({
      method: 'get',
      url: '/customers/' + payload.customerId + '/subscriptionusers/' + payload.userId + '/subscriptions'
    })
      .then(response => {
        context.commit('setAllSubscriptions', { data: response.data, error: null })
      })
      .catch(error => {
        context.commit('setAllSubscriptionsError', error.message)
      })
  },

  /* -------SAVE-------- */
  /* -------DELETE-------- */
  /* -------RESET-------- */
  resetCurrentUser: function (context) {
    context.commit('resetStates')
  },

  /* -------OTHER-------- */
  removeSubscriptionsFromUser: function (context, subscriptions) {
    for (let subId of subscriptions) {
      context.commit('removeSubscription', subId)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
